var Slider = void 0;
if (process.browser) {
  Slider = require('vue-slider-component');
}
export default Slider;


//////////////////
// WEBPACK FOOTER
// ./plugins/slider.js
// module id = ./plugins/slider.js
// module chunks = 152